<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('homework.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('homework.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <staff-homework v-if="isStaff" />
    <teacher-homework v-if="isTeacher" />
    <student-homework v-if="isStudent" />
    <parent-homework v-if="isParent" />
  </div>
</template>

<script>
import StaffHomework from './staff/index'
import TeacherHomework from './teacher/index'
import StudentHomework from './student/index'
import ParentHomework from './parent/index'

export default {
  name: 'homework',
  components: {
    StaffHomework,
    TeacherHomework,
    StudentHomework,
    ParentHomework
  },
  data() {
    return {}
  },
  computed: {
    isStaff() {
      return this.$store.getters.isStaffLogin
    },
    isTeacher() {
      return this.$store.getters.isTeacherLogin
    },
    isStudent() {
      return this.$store.getters.isStudentLogin
    },
    isParent() {
      return this.$store.getters.isParentLogin
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('eschool/teacherHomework/RESET_STATE')
    this.$store.commit('eschool/staffHomework/RESET_STATE')
    this.$store.commit('eschool/studentHomework/RESET_STATE')
    next()
  }
}
</script>
